
////////////////////
// Template
////////////////////
const template = /*html*/ `

    <div class="c-cart-items || o-padding -padding-tiny-top -padding-tiny-bottom">

        <!-- Items -->
        <ul v-if='this.cart && this.cart.items && this.cart.items.length' class="c-cart-items_list">
            <cart-item
                v-for="(cartItem, index) in cart.items"
                ref="item"
                :variant-id="cartItem.variant_id"
                :quantity="cartItem.quantity"
                :price="cartItem.line_price"
                :compare-at-price="cartItem.original_line_price"
                :product-title="cartItem.product_title"
                :product-key="cartItem.key"
                :image="cartItem.image"
                :selected-options="cartItem.options_with_values"
                :module-instance="moduleInstance"
                :currency-iso-code='currencyIsoCode'
                :currency-symbol='currencySymbol'
                :delete-label="deleteLabel"
                :properties="cartItem.properties"
                :key="index"
            />
        </ul>

        <!-- Empty message -->
        <div v-else class="c-cart_empty">
            <p class="c-heading -h6">
                <slot name="empty-cart"></slot>
            </p>
        </div>
    </div>

`;


////////////////////
// Scripts
////////////////////
export default function VueCart(moduleInstance) {

    Vue.component("cart", {

        template,

        props: {
            currencyIsoCode: {
                type: String,
                required: true
            },
            currencySymbol: {
                type: String,
                required: true
            },
            deleteLabel: {
                type: String,
                default: 'Delete'
            }
        },

        data() {
            return {
                cart: [],
                moduleInstance: moduleInstance
            };
        },

        methods: {
            setCartData(rawCart) {
                this.cart = rawCart

                this.$nextTick(() => {
                    const $items = this.$refs.item

                    if (!$items) return

                    $items.forEach($item => {
                        $item?.setImage?.()
                    });
                })
            }
        }
    });
}
